import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { SecretaryAreaFull } from '@/features/secretary/SecretaryAreaFull';
import { MobileSecretaryArea } from '@/features/secretary/mobile/MobileSecretaryArea';
import { SECRETARY_TAB_LABEL, type SecretaryTab } from '@/features/secretary/secretaryQueues';

/* `?tab=` apre una scheda precisa: ci porta il widget della home «Code della segreteria». Una
   scheda che chi guarda non può usare si ignora, e si apre la prima delle sue. */
const isTab = (v: unknown): v is SecretaryTab => typeof v === 'string' && v in SECRETARY_TAB_LABEL;

export const Route = createFileRoute('/_app/secretary/area')({
  validateSearch: (s: Record<string, unknown>): { tab?: SecretaryTab } => (isTab(s.tab) ? { tab: s.tab } : {}),
  component: SecretaryAreaRoute,
});

/** Selettore: area segreteria mobile (MaeDesign) vs hub desktop a tabelle. */
function SecretaryAreaRoute() {
  const isMobile = useIsMobileShell();
  const { tab } = Route.useSearch();
  return isMobile ? <MobileSecretaryArea initialTab={tab} /> : <SecretaryAreaFull initialTab={tab} />;
}
